import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Contact section — info panel + CTA to booking wizard.
 * The legacy form (Name, Email, Message) has been replaced with a sleek CTA.
 */
export default function Contact() {
  const navigate = useNavigate();

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className="contact-card">
          <div className="contact-layout">
            <div className="contact-info">
              <h2>Inquiries & Reservations</h2>
              <p>
                Whether you seek a bespoke session or wish to explore our full suite of services,
                our team is dedicated to perfecting your experience.
              </p>
              <div className="contact-details">
                <p><strong>Email:</strong> anamika@glaminant.com</p>
                <p><strong>Phone:</strong> +1 778 968 2728</p>
                <p><strong>Concierge Hours:</strong> Mon - Sun, 9am - 9pm</p>
              </div>
              <div className="whatsapp-qr-container">
                <p><strong>Message us on WhatsApp:</strong></p>
                <img src={require('../assets/whatsapp-qr.png')} alt="WhatsApp QR Code" className="whatsapp-qr" />
              </div>
            </div>

            <div className="contact-cta">
              <div className="cta-content">
                <h3>Ready to Glow?</h3>
                <p>Book your personalized experience in just a few clicks.</p>
                <p className="cta-zone-note">Currently bringing elegance to Greater Vancouver</p>
                <button
                  className="btn cta-book-btn"
                  onClick={() => navigate('/book')}
                >
                  Book Your Experience →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
